// @router

import { RouteConfig } from "vue-router";
const newContainer = () => import("@/layouts/Default.vue");
const routerParrent = () => import("@/components/base/routerParrent.vue");
const searchCompetency = () =>
  import("../views/competency/searchCompetency.vue");
const searchIndicator = () => import("../views/indicator/searchIndicator.vue");
const exerciseDesignPage = () =>
  import("../views/exercise/exercise_design/exerciseDesignPage.vue");
const searchAlgorithm = () =>
  import("../views/exercise/algorithm/searchAlgorithm.vue");
const searchTemplate = () => import("../views/template/searchTemplate.vue");
const searchAssessment_plan = () =>
  import("../views/assessment_plan/searchAssessment_plan.vue");
const SearchCenter_execute = () =>
  import("../views/center_execute/searchCenter_execute.vue");
const EndedCenterExecute = () =>
  import("../views/center_execute/endedCenterExecute.vue");
const SearchDayCenterRoom = () =>
  import("../views/day_center_room/searchDayCenterRoom.vue");
const SearchCenterExecuteCase = () =>
  import("../views/center_execute_case/searchCenterExecuteCase.vue");
const SearchWashUp = () => import("../views/wash_up/searchWashUp.vue");
const AddCompetency = () => import("../views/competency/addCompetency.vue");
const AddIndicator = () => import("../views/indicator/addIndicator.vue");
const AddExercise = () => import("../views/exercise/addExercise.vue");
const AddAlgorithm = () =>
  import("../views/exercise/algorithm/addAlgorithm.vue");
const AddTemplate = () => import("../views/template/addTemplate.vue");
const AddAssessment_plan = () =>
  import("../views/assessment_plan/addAssessment_plan.vue");
const AddCenter_execute = () =>
  import("../views/center_execute/addCenter_execute.vue");
const AddDayCenterRoom = () =>
  import("../views/day_center_room/addDayCenterRoom.vue");
const editCompetency = () => import("../views/competency/editCompetency.vue");
const editExercise = () => import("../views/exercise/editExercise.vue");
const editAlgorithm = () =>
  import("../views/exercise/algorithm/editAlgorithm.vue");
const EditIndicator = () => import("../views/indicator/editIndicator.vue");
const editTemplate = () => import("../views/template/editTemplate.vue");
const EditAssessment_plan = () =>
  import("../views/assessment_plan/editAssessment_plan.vue");
const EditCenter_execute = () =>
  import("../views/center_execute/editCenter_execute.vue");
const EditDayCenterRoom = () =>
  import("../views/day_center_room/editDayCenterRoom.vue");
const EditCenterExecuteCaseCompetency = () =>
  import(
    "../views/center_execute_case_competency/editCenterExecuteCaseCompetency.vue"
  );
const assessmentPlanPseudoData = () =>
  import("../views/assessment_plan_data/assessmentPlanPseudoData.vue");
const schedulerPage = () => import("../views/scheduler/schedulerPage.vue");
const exerciseCard = () => import("../views/exercise/exerciseCard.vue");
const markingCompetencyPage = () =>
  import("../views/center_execute_case_competency/markingCompetencyPage.vue");
const OverviewPage = () => import("../views/wash_up/overviewPage.vue");
const underConstruction = () =>
  import("../views/underConstruction/underConstructionPage.vue");
const analyticalReport = () => import("../views/reports/analyticalReport.vue");
const indicatorEvidence = () =>
  import("../views/indicator/indicatorEvidence.vue");
const indicatorExerciseEvidence = () =>
  import("../views/indicator/indicatorExerciseEvidence.vue");
const competencyIndicator = () =>
  import("../views/competency/competencyIndicator.vue");

/* redesign */
// evidence
const searchEvidence = () =>
  import("../views/evidence/re-design/searchEvidence.vue");
const addEvidence = () => import("../views/evidence/re-design/addEvidence.vue");
const editEvidence = () =>
  import("../views/evidence/re-design/editEvidence.vue");
// center execute
const centerExecuteList = () =>
  import("../views/re-design/center-execute/centerExecuteList.vue");
const centerExecuteEdit = () =>
  import(
    "../views/re-design/center-execute/center-execute-edit/centerExecuteEdit.vue"
  );
const listCenterExecuteCases = () =>
  import("../views/re-design/center-execute-cases/listCenterExecuteCases.vue");
const centerExecuteCaseCompetency = () =>
  import(
    "../views/re-design/center-execute-case-competency/centerExecuteCaseCompetency.vue"
  );
const listWashup = () => import("../views/re-design/washup/listWashup.vue");
const competencyOverview = () =>
  import("../views/re-design/washup/competencyOverview.vue");
const editWashup = () => import("../views/re-design/washup/editWashup.vue");
const meetingBoard = () =>
  import("../views/re-design/meeting-board/meetingBoard.vue");
const centerExecuteAccessList = () =>
  import(
    "../views/re-design/center-execute-access/centerExecuteAccessList.vue"
  );
const centerExecutePlannerList = () =>
  import(
    "../views/re-design/center-execute-planner/centerExecutePlannerList.vue"
  );
const centerExecutePlannerEdit = () =>
  import(
    "../views/re-design/center-execute-planner/centerExecutePlannerEdit.vue"
  );
const completeInfoList = () =>
  import("../views/re-design/complete-info/completeInfoList.vue");
const endedCenterExecuteList = () =>
  import(
    "../views/re-design/ended-center-execute-list/endedCenterExecuteList.vue"
  );
const myCenterExecuteList = () =>
  import("../views/re-design/my-center-execute-list/myCenterExecuteList.vue");

export const kanoonRoutes: RouteConfig[] = [
  {
    path: "/ac",
    redirect: "/dashboard",
    name: "dynamic_home",
    meta: {
      hasBottomNavigation: false,
      label: "خانه",
      requiresAuth: true,
    },
    component: newContainer,
    children: [
      {
        path: "exercise",
        name: "exercise",
        redirect: "/ac/exercise/search",
        component: routerParrent,
        meta: {
          hasBottomNavigation: false,
          label: "تمرین",
          deprecated: true,
        },
        children: [
          {
            path: "add",
            name: "addExercise",
            component: AddExercise,

            meta: {
              hasBottomNavigation: false,
              label: "ایجاد تمرین",
              deprecated: true,
            },
          },
          {
            path: "search",
            name: "exerciseSearch",
            component: exerciseCard,
            meta: {
              hasBottomNavigation: true,
              label: "جستجوی تمرین",
              deprecated: true,
            },
          },
          {
            path: "edit/:id",
            name: "editExercise",
            component: editExercise,
            meta: {
              hasBottomNavigation: false,
              label: "ویرایش تمرین",
              deprecated: true,
            },
          },
          {
            path: "exerciseDesign/:id",
            name: "exerciseDesign",
            component: exerciseDesignPage,
            meta: {
              hasBottomNavigation: false,
              label: "طراحی تمرین",
              deprecated: true,
            },
          },
          {
            path: ":id/algorithm",
            name: "algorithm",
            redirect: "/ac/exercise/edit/:id",
            component: routerParrent,
            meta: {
              hasBottomNavigation: false,
              label: "مراحل اجرای تمرین",
              deprecated: true,
            },
            children: [
              {
                path: "search",
                name: "searchAlgorithm",
                component: searchAlgorithm,
                meta: {
                  hasBottomNavigation: false,
                  label: "جستجوی الگوریتم تمرین",
                  deprecated: true,
                },
              },
              {
                path: "add",
                name: "AddAlgorithm",
                component: AddAlgorithm,
                meta: {
                  hasBottomNavigation: false,
                  label: "الگوریتم تمرین",
                  deprecated: true,
                },
              },
              {
                path: "edit/:algorithm_id",
                name: "editAlgorithm",
                component: editAlgorithm,
                meta: {
                  hasBottomNavigation: false,
                  label: "جزئیات مرحله اجرای تمرین",
                  deprecated: true,
                },
              },
            ],
          },
        ],
      },
      {
        path: "assessment_plan",
        name: "assessment_plan",
        redirect: "/ac/assessment_plan/search",
        // component: routerParrent,
        meta: {
          deprecated: true,
          hasBottomNavigation: false,
          label: "برنامه ارزیابی",
        },
        children: [
          {
            path: "search",
            name: "searchAssessment_plan",
            // component: searchAssessment_plan,
            meta: {
              hasBottomNavigation: true,
              label: "جستجوی برنامه ارزیابی",
              deprecated: true,
            },
          },
          {
            path: "add",
            name: "AddAssessment_plan",
            // component: AddAssessment_plan,
            meta: {
              hasBottomNavigation: false,
              label: "ایجاد برنامه ارزیابی",
              deprecated: true,
            },
          },
          {
            path: "edit/:id",
            name: "EditAssessment_plan",
            // component: EditAssessment_plan,
            meta: {
              hasBottomNavigation: false,
              label: "ویرایش برنامه ارزیابی",
              deprecated: true,
            },
          },
          {
            path: "pseudo_data/:id",
            name: "assessment_plan_pseudo_data",
            // component: assessmentPlanPseudoData,
            meta: {
              hasBottomNavigation: false,
              label: "داده‌های برنامه ارزیابی",
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "center-execute-planner",
        name: "center_execute_with_access",
        redirect: "/ac/center-execute-planner/list",
        component: routerParrent,
        meta: {
          hasBottomNavigation: false,
          label: "کانون",
          deprecated: true,
        },
        children: [
          {
            path: "list",
            name: "center-execute-planner",
            component: centerExecutePlannerList,
            meta: {
              hasBottomNavigation: true,
              label: "برنامه‌ریز کانون",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":centerExecuteId/edit",
            name: "center-execute-planner-edit",
            component: centerExecutePlannerEdit,
            meta: {
              hasBottomNavigation: false,
              label: "ویرایش کانون",
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "center-execute-access",
        name: "center_execute_access",
        redirect: "/ac/center-execute-access/list",
        component: routerParrent,
        meta: {
          hasBottomNavigation: false,
          label: "کانون",
        },
        children: [
          {
            path: "list",
            name: "center-execute-access",
            // component: centerExecuteAccessList,
            meta: {
              hasBottomNavigation: true,
              label: "دسترسی برنامه‌ریز کانون",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "center-execute",
        name: "center_execute",
        redirect: "/ac/center-execute/all",
        // component: routerParrent,
        meta: {
          hasBottomNavigation: true,
          label: "کانون",
          deprecated: true,
        },
        children: [
          {
            path: "all",
            name: "center-execute-list",
            // component: centerExecuteList,
            meta: {
              hasBottomNavigation: true,
              label: "اجرای کانون",
              deprecated: true,
            },
          },
          {
            path: "my",
            name: "my_center_execute",
            // component: myCenterExecuteList,
            meta: {
              hasBottomNavigation: true,
              label: "کانون‌های من",
              deprecated: true,
            },
          },
          {
            path: "ended",
            name: "ended_center_execute",
            // component: endedCenterExecuteList,
            meta: {
              hasBottomNavigation: true,
              label: "کانون‌های پایان یافته",
              deprecated: true,
            },
          },
          {
            path: "cases",
            name: "all_center_execute_case",
            // component: listCenterExecuteCases,
            meta: {
              hasBottomNavigation: true,
              label: "کل پرونده‌های کانون",
              deprecated: true,
            },
          },
          {
            path: ":centerExecuteId/cases",
            name: "center-execute-cases",
            // component: listCenterExecuteCases,
            meta: {
              hasBottomNavigation: false,
              label: "پرونده‌های کانون",
              deprecated: true,
            },
          },
          {
            path: ":centerExecuteId/cases/:caseId/competency",
            name: "center-execute-case-competency",
            // component: centerExecuteCaseCompetency,
            meta: {
              hasBottomNavigation: false,
              label: "علامت گذاری شایستگی",
              deprecated: true,
              hasMaxWidth: false,
            },
          },
          {
            path: ":centerExecuteId/edit",
            name: "center-execute-edit",
            // component: centerExecuteEdit,
            meta: {
              hasBottomNavigation: false,
              label: "ویرایش کانون",
              deprecated: true,
            },
          },
          {
            path: ":centerExecuteId/washup",
            name: "washup",
            // component: routerParrent,
            meta: {
              hasBottomNavigation: false,
              label: "جمع‌بندی",
              deprecated: true,
            },
            children: [
              {
                path: "list",
                name: "list-washup",
                // component: listWashup,
                meta: {
                  hasBottomNavigation: false,
                  label: "وضعیت پرونده‌ها",
                  deprecated: true,
                  hasMaxWidth: false,
                },
              },
              {
                path: "competency-overview",
                name: "washup-competency-overview",
                // component: competencyOverview,
                meta: {
                  hasBottomNavigation: false,
                  label: "جمع‌بندی شایستگی",
                  deprecated: true,
                  hasMaxWidth: false,
                },
              },
              {
                path: ":candidateId/edit",
                name: "edit-washup",
                // component: editWashup,
                meta: {
                  hasBottomNavigation: false,
                  label: "ویرایش جمع‌بندی",
                  deprecated: true,
                  hasMaxWidth: false,
                },
              },
            ],
          },
        ],
      },
      {
        path: "competency",
        redirect: "/ac/competency/search",
        name: "competency",
        component: routerParrent,
        meta: {
          hasBottomNavigation: false,
          label: "شایستگی",
          deprecated: true,
        },
        children: [
          {
            path: "search",
            name: "searchCompetency",
            // component: searchCompetency,
            meta: {
              hasBottomNavigation: true,
              label: "جستجوی شایستگی",
              deprecated: true,
            },
          },
          {
            path: "add",
            name: "addCompetency",
            // component: AddCompetency,
            meta: {
              hasBottomNavigation: false,
              label: "ایجاد شایستگی",
              deprecated: true,
            },
          },
          {
            path: "edit/:id",
            name: "editCompetency",
            // component: editCompetency,
            meta: {
              deprecated: true,
              hasBottomNavigation: false,
              label: "ویرایش شایستگی",
            },
          },
          {
            path: "indicator/:id",
            name: "competencyIndicator",
            // component: competencyIndicator,
            meta: {
              deprecated: true,
              hasBottomNavigation: false,
              label: "ارتباط شایستگی با نشانگر",
            },
          },
        ],
      },
      {
        path: "under_construction",
        name: "در حال توسعه",
        component: underConstruction,
      },
      {
        path: "indicator",
        name: "indicator",
        redirect: "/ac/indicator/list",
        // component: routerParrent,
        meta: {
          hasBottomNavigation: false,
          label: "نشانگر",
          deprecated: true,
        },
        children: [
          {
            path: "list",
            name: "indicatorList",
            // component: indicatorList,
            meta: {
              label: "جستجوی نشانگر",
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "template",
        name: "template",
        redirect: "/ac/template/list",
        component: routerParrent,
        meta: {
          label: "قالب",
          deprecated: true,
        },
        children: [
          {
            path: "list",
            name: "templateList",
            // component: templateList,
            meta: {
              label: "جستجوی قالب",
              deprecated: true,
            },
          },
          {
            path: "competency-exercise-matrix/:id",
            name: "competencyExerciseMatrix",
            // component: competencyExerciseMatrix,
            meta: {
              label: "ماتریس تمرین-شایستگی",
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "evidence",
        name: "evidence",
        redirect: "/ac/evidence/search",
        component: routerParrent,
        meta: {
          deprecated: true,
          hasBottomNavigation: false,
          label: "مصادیق",
        },
        children: [
          {
            path: "search",
            name: "evidence",
            // component: searchEvidence,
            meta: {
              hasBottomNavigation: true,
              label: "لیست مصادیق",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: "add",
            name: "add-evidence",
            // component: addEvidence,
            meta: {
              deprecated: true,
              hasBottomNavigation: false,
              label: "مصداق جدید",
              requiresAuth: true,
            },
          },
          {
            path: "edit/:id",
            name: "edit-evidence",
            // component: editEvidence,
            meta: {
              deprecated: true,
              hasBottomNavigation: false,
              label: "ویرایش مصداق",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "meeting-board",
        name: "center_execute_meeting_board",
        component: meetingBoard,
        meta: {
          hasBottomNavigation: true,
          label: "دریافت فایل گزارش عملکرد ارزیابی",
          requiresAuth: true,
          deprecated: true,
        },
      },
      {
        path: "complete-info",
        name: "center_execute_complete_info",
        component: completeInfoList,
        meta: {
          hasBottomNavigation: true,
          label: "گزارش کامل کانون",
          requiresAuth: true,
          deprecated: true,
        },
      },
    ],
  },
];
